import React, { useState, useContext, useMemo } from 'react'
import { ThemeContext } from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

import { InputLabel, StyledReactSelect } from './styles'

const PageSizeSelect = props => {
  const [isFocused, setFocused] = useState(false)
  const theme = useContext(ThemeContext)

  const customStyles = useMemo(() => ({
    control: (provided, state) => {
      const boxShadow = state?.isFocused && theme.shadows.under[1]
      const borderColor = state?.isFocused
        ? theme.colors.primary
        : state?.isDisabled
        ? theme.colors.grays.N300
        : theme.colors.grays.N500
      const backgroundColor = theme.colors.white

      return { ...provided, backgroundColor, boxShadow, borderRadius: '8px', borderColor, '&:hover': { borderColor } }
    },

    singleValue: provided => ({ ...provided, color: theme.colors.text }),

    input: provided => ({
      ...provided,
      color: theme.colors.text,
      margin: 0,
    }),

    valueContainer: provided => ({ ...provided, padding: '4px 16px' }),

    placeholder: (provided, state) => ({
      ...provided,
      margin: 0,
      color: state.isDisabled ? theme.colors.grays.N300 : theme.colors.grays.N800,
    }),

    menu: provided => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: `0 0 0 1px ${theme.colors.primary}, ${theme.shadows.under[1]}`,
      'z-index': 11,
    }),

    option: (provided, state) => {
      const styles = {
        ...provided,
        color: theme.colors.text,
        backgroundColor: state.isFocused ? theme.colors.primary : provided.backgroundColor,
      }

      if (!state.isSelected) {
        return styles
      }

      return {
        ...styles,
        borderLeft: `4px solid ${theme.colors.primary}`,
        paddingLeft: '8px',
        backgroundColor: 'transparent',
        '&:hover': { backgroundColor: theme.colors.primary },
      }
    },
  }))

  return (
    <Flex
      flexBasis='45%'
      minWidth='120px'
      flexGrow='1'
      alignItems={['center', 'center', 'flex-start']}
      flexDirection='column'
    >
      <StyledReactSelect
        {...props}
        styles={customStyles}
        components={{ IndicatorSeparator: null }}
        value={{ label: props.value, value: props.value }}
        options={props.options.map(value => ({ label: value, value }))}
        onChange={({ value }) => props.onChange(Number(value))}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        menuPlacement='top'
      />
      <InputLabel focused={isFocused}>Items por página</InputLabel>
    </Flex>
  )
}

export default PageSizeSelect
